import { useRef } from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";

export default function Hardware({ hardware1, hardware2, hardware3 }) {
  const settings3 = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const slider3 = useRef(null);

  return (
    <section data-aos="fade-up" className="payment-sec">
      <div className="container">
        <div className="d-md-flex gap-2 justify-content-between h-100">
          <div className="pos_tile text-start col-lg-7 mb-3">
            <h1 className="mb-0">Hardware that’s ready for the rush</h1>
          </div>
          <div className="mb-2 d-flex gap-2 align-items-center mb-3">
            <div className="left-slide ">
              <div
                role="button"
                onClick={() => slider3?.current?.slickPrev()}
                className="arr-85 p-4 rounded-circle"
              >
                <ArrowBackIcon />
              </div>
            </div>
            <div className="right-slide ">
              <div
                role="button"
                onClick={() => slider3?.current?.slickNext()}
                className="arr-85 p-4 rounded-circle"
              >
                <ArrowForwardIcon />
              </div>
            </div>
          </div>
        </div>

        <Slider ref={slider3} dots {...settings3} className="">
          <div className=" mb-3">
            <div className="c mb-3">
              <img
                loading="lazy"
                src={hardware1?.img ?? "/assets/img/clothing/C20.webp"}
                alt=""
                className="w-100"
              />
            </div>
            <div className="pos_tile">
              <h2 className="mb-3">
                {hardware1?.title ?? "Fusion Dual Premium POS"}
              </h2>
              <p className="text-black ">
                {hardware1?.desc ??
                  `Dual screens | Built-in printer | Full payment support`}
              </p>
              {/* <p>
                Inbuilt 80mm Printer , 4G/Wi-Fi/Bluetooth, Accepts all payment
                types
              </p> */}
              <Link to="/get-started" className="text-color">
                {hardware1?.cta ?? "Explore Premium POS"}{" "}
              </Link>
            </div>
          </div>
          <div className=" mb-3">
            <div className="c mb-3">
              <img
                loading="lazy"
                src={hardware2?.img ?? "/assets/img/clothing/printer.webp"}
                alt=""
                className="w-100"
              />
            </div>
            <div className="pos_tile">
              <h2 className="mb-3">
                {hardware2?.title ?? "Fusion Portable POS"}
              </h2>
              <p className="text-black ">
                {hardware2?.desc ??
                  `Handheld | Long battery | On-the-go sales`}
              </p>
              {/* <p>
                Inbuild 80mm Printer, Accepts all payment types,
                4G/Wi-Fi/Bluetooth
              </p> */}
              <Link to="/get-started" className="text-color">
                {hardware2?.cta ?? "Try Portable POS"}{" "}
              </Link>
            </div>
          </div>
          <div className=" mb-3">
            <div className="c mb-3">
              <img
                loading="lazy"
                src={hardware3?.img ?? "/assets/img/clothing/S700.webp"}
                alt=""
                className="w-100"
              />
            </div>
            <div className="pos_tile">
              <h2 className="mb-3">
                {hardware3?.title ?? "Fusion ProPay Reader"}
              </h2>
              <p className="text-black ">
                {hardware3?.desc ??
                  `Pocket-size | Tap & chip | No fees`}
              </p>
              {/* <p>Chip & contactless, Up to 12 hours battery</p> */}
              <Link to="/get-started" className="text-color">
                {hardware3?.cta ?? "Get ProPay Reader"}{" "}
              </Link>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
}

Hardware.propTypes = {
  hardware1: PropTypes.object,
  hardware2: PropTypes.object,
  hardware3: PropTypes.object,
};
